import React from "react";

const useAudio = () => {
  const audioRef = React.useRef();
  const [isPlaying, setIsPlaying] = React.useState(false);

  const togglePlay = () => {
    isPlaying ? audioRef.current.pause() : audioRef.current.play();
    setIsPlaying(!isPlaying);
  };

  const handleOnEnded = () => setIsPlaying(false);

  return [audioRef, togglePlay, handleOnEnded];
};

export default useAudio;
